(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kingrock-menu-controls"] && !Shopify.designMode) return;
  try {
    function setupKingrockMenu(root) {
    root.querySelectorAll('.kr-menu-toggle').forEach((button) => {
      if (button.dataset.krReady) return;
      button.dataset.krReady = 'true';
      const item = button.parentElement;
      const setOpen = (open) => {
        button.setAttribute('aria-expanded', String(open));
        item.classList.toggle('is-expanded', open);
        if (!open) {
          item.querySelectorAll('.kr-menu-toggle').forEach((child) => {
            if (child === button) return;
            child.setAttribute('aria-expanded', 'false');
            child.parentElement.classList.remove('is-expanded');
          });
        }
      };
      item.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') setOpen(true);
      });
      item.addEventListener('pointerleave', () => {
        if (!item.contains(document.activeElement)) setOpen(false);
      });
      item.addEventListener('focusin', (event) => {
        if (event.target !== button) setOpen(true);
      });
      item.addEventListener('focusout', (event) => {
        if (!item.contains(event.relatedTarget)) setOpen(false);
      });
      button.addEventListener('click', () => {
        setOpen(button.getAttribute('aria-expanded') !== 'true');
      });
      item.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;
        event.preventDefault();
        event.stopPropagation();
        button.focus();
        setOpen(false);
      });
      document.addEventListener('click', (event) => {
        if (!item.contains(event.target)) setOpen(false);
      });
    });
  }
  setupKingrockMenu(document);
  document.addEventListener('shopify:section:load', (event) => setupKingrockMenu(event.target));
  } catch(e) { console.error(e); }
})();

})();
